export const ourDomains = ['car.gr', 'plot.gr']
